__turbopack_context__.v({
  "banner-slider": "banner-slider-component-module-scss-module__RVnxnW__banner-slider",
});
